var Q = Object.defineProperty;
var V = (o, t, e) => t in o ? Q(o, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : o[t] = e;
var g = (o, t, e) => V(o, typeof t != "symbol" ? t + "" : t, e);
import { j as s } from "./jsx-runtime-3tyXYecC.mjs";
import Y, { Fragment as L, forwardRef as J, Component as O } from "react";
import { f as d } from "./index-LyFokDcn.mjs";
import { m as P } from "./tss-DN0acMKN.mjs";
import { M as v, d as _ } from "./constants-CnFYFetN.mjs";
import { d as G, f as K, k as X } from "./keys-CQjWNUL0.mjs";
import { L as A } from "./link-unstyled-CvXR-8s6.mjs";
import { I as k } from "./icon-v2-DGtVEk7e.mjs";
import { u as Z } from "./index-DFOMnLtx.mjs";
import { l as N } from "./lodash-5ofSKtz3.mjs";
import { c as T } from "./index-DkZ16bcJ.mjs";
import { B as ee } from "./button-CUHBhgeQ.mjs";
import { d as I } from "./debounce-C75qbvjB.mjs";
import { g as te } from "./_commonjsHelpers-BkfeUUK-.mjs";
import { c as oe } from "./_arrayPush-DUvcoEi5.mjs";
import { n as F } from "./compact-CN4wKJco.mjs";
import { L as ne } from "./loader-CJQkrVUR.mjs";
import { a as ie } from "./index-isgVnOkQ.mjs";
const re = P()(({ mode: o, palette: t, typography: e }) => ({
  root: {
    color: o === v.Dye ? _.main : t.gray[700],
    fontSize: d.ifFeature("encore", e.large.fontSize, e.small.fontSize)
  }
}));
function se({ pageSize: o, currentPage: t = 1, totalItemsCount: e, pageCount: n }) {
  let i = o * t, a = i - o + 1;
  const r = e - Math.floor(e / o) * o;
  return r !== 0 && n === t && (i = e, a = e - r + 1), {
    topRange: i,
    lowerRange: a
  };
}
function ae(o) {
  const { totalItemsCount: t } = o, { topRange: e, lowerRange: n } = se(o), { classes: i } = re();
  return /* @__PURE__ */ s.jsx("span", { className: i.root, children: `${n === t ? "" : `${n}-`}${e} of ${t}` });
}
var w = {}, M = {}, R;
function le() {
  return R || (R = 1, function(o) {
    var t = G;
    t(o, "__esModule", {
      value: !0
    }), o.buildTrackingDataAttributes = e;
    function e(n, i) {
      return i ? {
        "data-trackingaction": n,
        "data-category": i
      } : {};
    }
  }(M)), M;
}
(function(o) {
  var t, e = G, n = K, i = X;
  e(o, "__esModule", {
    value: !0
  });
  var a = le();
  n(t = i(a)).call(t, function(r) {
    r === "default" || r === "__esModule" || r in o && o[r] === a[r] || e(o, r, {
      enumerable: !0,
      get: function() {
        return a[r];
      }
    });
  });
})(w);
function p(o, t) {
  return o = N.isFunction(o) ? o : Z.extendURL, o({ page: t });
}
const ce = P()(({ mode: o, palette: t, typography: e }, { isActive: n }, i) => ({
  root: d.ifFeature(
    "encore",
    {
      "& .MuiButton-root": {
        minWidth: "unset",
        height: "32px",
        width: "32px",
        "&:hover": n && {
          color: t.common.white
        },
        "&:focus-visible": n && {
          color: t.common.white
        }
      }
    },
    {
      backgroundColor: o === v.Dye ? _.lightest : t.grey[100],
      borderColor: "transparent",
      borderRadius: "2px",
      borderStyle: "solid",
      borderWidth: "1px",
      fontSize: e.small.fontSize,
      lineHeight: "22px",
      textAlign: "center",
      "&:hover": {
        backgroundColor: o === v.Dye ? _.main : t.primary.lighter
      },
      [`&:hover .${i.link}`]: {
        color: t.common.white
      },
      ...n ? {
        backgroundColor: t.common.white,
        borderColor: o === v.Dye ? _.main : t.primary.lighter,
        "&:hover": {
          backgroundColor: o === v.Dye ? _.main : t.primary.main
        }
      } : {}
    }
  ),
  link: {
    color: n ? t.primary.main : t.grey[700],
    display: "block",
    padding: "0 8px",
    textDecoration: "none",
    "&:hover": {
      textDecoration: "none"
    }
  }
}));
function D({ className: o, value: t, isActive: e, handlePageClick: n, url: i, trackingAttributes: a }) {
  const { classes: r } = ce({ isActive: e });
  function l(f) {
    n(f, t);
  }
  const c = /* @__PURE__ */ s.jsx("li", { ...a, className: T(o, r.root), children: /* @__PURE__ */ s.jsx(
    ee,
    {
      "aria-label": `Page ${t}`,
      color: "primary",
      href: i,
      onClick: l,
      size: "teenie",
      variant: e ? "contained" : "outlined",
      children: t
    }
  ) });
  return d.ifFeature(
    "encore",
    c,
    /* @__PURE__ */ s.jsx("li", { ...a, className: T(o, r.root), onClick: l, children: /* @__PURE__ */ s.jsx("a", { "aria-label": `Page ${t}`, className: r.link, href: i, children: t }) })
  );
}
const de = P()(({ palette: o }) => ({
  root: {
    alignSelf: d.ifFeature("encore", "center"),
    background: "none",
    borderColor: "transparent",
    borderRadius: "2px",
    borderStyle: "solid",
    borderWidth: "1px",
    color: o.gray[700],
    fill: d.ifFeature("encore", o.gray[300]),
    fontSize: "20px",
    letterSpacing: "1px",
    lineHeight: "12px",
    textAlign: "center",
    width: "22px",
    "&:hover": {
      backgroundColor: d.ifFeature("encore", void 0, o.primary.lighter)
    }
  }
}));
function C({ className: o }) {
  const { classes: t } = de({ isHidden: !0 });
  return /* @__PURE__ */ s.jsx("li", { className: T(o, t.root), children: d.ifFeature("encore", /* @__PURE__ */ s.jsx(k, { name: "ellipsis-regular", size: 20 }), "...") });
}
const he = P()(
  ({ mode: o, palette: t, typography: e, spacing: n, mixins: i, borderRadiuses: a }, { isLastPage: r = !1 }, l) => ({
    root: {
      display: "flex",
      flexWrap: "nowrap",
      flexDirection: "row",
      outline: o === v.Dye ? `1px solid ${_.main}` : void 0,
      alignItems: d.ifFeature("encore", "center")
    },
    list: {
      display: "flex",
      flexWrap: "nowrap",
      flexDirection: "row"
    },
    link: {
      color: t.link.main,
      fill: t.link.main,
      position: "relative",
      textDecoration: "none",
      fontSize: e.teenie.fontSize,
      lineHeight: e.teenie.lineHeight,
      "&:hover": {
        textDecoration: "underline"
      },
      "&:hover, &:focus-visible": {
        color: t.primary.main,
        fill: t.primary.main
      },
      "&:focus-visible:after": {
        borderRadius: a[200],
        boxShadow: `0 0 0 2px ${i.alpha(t.primary.light, 0.8)}`,
        content: "''",
        position: "absolute",
        top: -4,
        right: 0,
        bottom: -4,
        left: 0,
        width: "unset"
      }
    },
    next: d.ifFeature(
      "encore",
      {
        fontWeight: e.fontWeightSemibold,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: n(0.5),
        padding: "0 12px",
        ...r ? {
          pointerEvents: "none",
          color: t.gray[700],
          fill: t.gray[700],
          fontSize: e.teenie.fontSize,
          lineHeight: e.teenie.lineHeight,
          opacity: 0.5,
          "&:hover": {
            textDecoration: "none"
          }
        } : {}
      },
      {
        color: t.info.main,
        fontSize: e.small.fontSize,
        textDecoration: "none",
        "&:hover": {
          textDecoration: "underline"
        },
        ...r ? {
          pointerEvents: "none",
          color: t.grey[500],
          "&:hover": {
            textDecoration: "none"
          }
        } : {}
      }
    ),
    prev: d.ifFeature(
      "encore",
      {
        fontWeight: e.fontWeightSemibold,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: n(0.5),
        padding: "0 12px"
      },
      {
        color: t.info.main,
        fontSize: e.small.fontSize,
        textDecoration: "none",
        "&:hover": {
          textDecoration: "underline"
        }
      }
    ),
    page: {
      marginLeft: d.ifFeature("encore", "7px", "8px"),
      "&:last-child": {
        marginRight: d.ifFeature("encore", "7px", "8px")
      }
    },
    hiddenPages: {
      marginLeft: "5px",
      marginRight: "5px",
      [`& + .${l.page}`]: {
        marginLeft: 0
      }
    }
  })
);
function pe({ currentPage: o, hrefBuilder: t, handlePageClick: e, pageCount: n, trackingCategory: i }) {
  const a = o === n, { classes: r, cx: l } = he({ isLastPage: a }), c = (x, E = 0, b) => {
    const j = [];
    for (let S = E; S < x; S++) {
      const h = S + 1, y = b && h === b || h === o, q = p(t, h);
      j.push(
        /* @__PURE__ */ s.jsx(
          D,
          {
            className: r.page,
            handlePageClick: e,
            isActive: y,
            trackingAttributes: w.buildTrackingDataAttributes(`Pagination_Page_${h}`, i),
            url: q,
            value: h
          },
          `page${h}`
        )
      );
    }
    return j;
  }, f = () => {
    const E = n > 6, b = E && o <= n - 4, j = E && !b, S = Math.floor((o + 3) / 4), h = o > 4 ? /* @__PURE__ */ s.jsxs(L, { children: [
      /* @__PURE__ */ s.jsx(
        D,
        {
          className: r.page,
          handlePageClick: e,
          isActive: !1,
          trackingCategory: i,
          url: p(t, 1),
          value: 1
        },
        "page1"
      ),
      /* @__PURE__ */ s.jsx(C, { className: r.hiddenPages })
    ] }, "beginningSection") : null, y = /* @__PURE__ */ s.jsxs(L, { children: [
      /* @__PURE__ */ s.jsx(C, { className: r.hiddenPages }),
      /* @__PURE__ */ s.jsx(
        D,
        {
          className: r.page,
          handlePageClick: e,
          isActive: !1,
          trackingCategory: i,
          url: p(t, n),
          value: n
        },
        `page${n}`
      )
    ] }, "endSection");
    switch (!0) {
      case b:
        return [
          h,
          ...c(4 * S, 4 * S - 4, o),
          y
        ];
      case j:
        return [h, ...c(n, n - 4)];
      default:
        return c(n);
    }
  };
  function u(x) {
    e(x, o + 1);
  }
  function m(x) {
    e(x, o - 1);
  }
  const z = /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
    window.jQuery ? $.__("Next") : "Next",
    /* @__PURE__ */ s.jsx(k, { name: "arrow-right-solid", size: 12 })
  ] });
  return /* @__PURE__ */ s.jsxs("section", { className: r.root, children: [
    o !== 1 && d.ifFeature(
      "encore",
      /* @__PURE__ */ s.jsxs(
        A,
        {
          className: l(r.link, r.prev),
          href: p(t, o - 1),
          onClick: m,
          size: "extra-small",
          ...w.buildTrackingDataAttributes("Pagination__prev", i),
          children: [
            /* @__PURE__ */ s.jsx(k, { name: "arrow-left-solid", size: 12 }),
            window.jQuery ? $.__("Prev") : "Prev"
          ]
        }
      ),
      /* @__PURE__ */ s.jsxs(
        "a",
        {
          className: r.prev,
          href: p(t, o - 1),
          onClick: m,
          ...w.buildTrackingDataAttributes("Pagination__prev", i),
          children: [
            "«",
            window.jQuery ? $.__("Prev") : "Prev"
          ]
        }
      )
    ),
    /* @__PURE__ */ s.jsx("ul", { className: r.list, children: f() }),
    d.ifFeature(
      "encore",
      o === n ? /* @__PURE__ */ s.jsx("span", { className: r.next, children: z }) : /* @__PURE__ */ s.jsx(
        A,
        {
          "aria-disabled": o === n,
          className: l(r.link, r.next),
          href: p(t, o + 1),
          onClick: u,
          size: "extra-small",
          ...w.buildTrackingDataAttributes("Pagination__next", i),
          children: z
        }
      ),
      /* @__PURE__ */ s.jsxs(
        "a",
        {
          "aria-disabled": o === n,
          className: r.next,
          href: p(t, o + 1),
          onClick: u,
          ...w.buildTrackingDataAttributes("Pagination__next", i),
          children: [
            window.jQuery ? $.__("Next") : "Next",
            "  »"
          ]
        }
      )
    )
  ] });
}
const fe = P()(() => ({
  root: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "nowrap",
    justifyContent: "space-between",
    lineHeight: "24px",
    "& *": {
      boxSizing: "border-box"
    }
  }
})), ue = J((o, t) => {
  const { children: e } = o, { classes: n } = fe();
  return /* @__PURE__ */ s.jsx("div", { className: n.root, "data-fabric-component": "ProgressiveLoader", ref: t, children: e });
});
class me extends O {
  constructor(e) {
    super(e);
    g(this, "handlePageClick", (e, n) => {
      const { deepLink: i, onPageChange: a, endpoint: r, fetchMore: l, pageSize: c, fullRefresh: f } = this.props, { currentPage: u } = this.state;
      if (f || (e.preventDefault(), n === u))
        return;
      const m = n;
      i && this.saveBrowserHistory(m), r && l({
        startsAt: (m - 1) * c,
        limit: c
      }), a && a({ currentPage: u, nextPage: m }), this.setState({
        currentPage: m
      });
    });
    const { currentPage: n } = e;
    this.state = {
      currentPage: n || 1
    };
  }
  saveBrowserHistory(e) {
    const { hrefBuilder: n } = this.props, i = p(n, e);
    window.history.pushState({ page: e }, "", i);
  }
  buildMarkup() {
    const { pageSize: e, totalItemsCount: n, hrefBuilder: i, trackingCategory: a } = this.props, { currentPage: r } = this.state, l = Math.ceil(n / e);
    return /* @__PURE__ */ s.jsxs(ue, { children: [
      /* @__PURE__ */ s.jsx(ae, { pageSize: e, totalItemsCount: n, currentPage: r, pageCount: l }),
      /* @__PURE__ */ s.jsx(pe, { pageCount: l, currentPage: r, hrefBuilder: i, trackingCategory: a, handlePageClick: this.handlePageClick })
    ] });
  }
  setPage(e) {
    this.setState({ currentPage: e });
  }
  componentDidUpdate(e) {
    const { currentPage: n } = this.props;
    n !== e.currentPage && this.setPage(n);
  }
  render() {
    const { children: e } = this.props;
    return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
      e,
      this.buildMarkup()
    ] });
  }
}
const ge = me;
var xe = oe();
const H = /* @__PURE__ */ te(xe);
function Se(o, t, e) {
  const n = "scrollTop" in t ? t.scrollTop : t.pageYOffset;
  return o.scrollHeight - Math.ceil(n) - e <= o.clientHeight;
}
function we(o) {
  return o.getBoundingClientRect().bottom > window.innerHeight;
}
function ve(o) {
  return o.tagName.toLowerCase() === "body" ? o.scrollHeight > window.innerHeight : o.scrollHeight > o.clientHeight;
}
const _e = 1, be = 250;
class Pe extends O {
  constructor() {
    super(...arguments);
    g(this, "handleResize", I(() => {
      const { preloadUntilScroll: e, preloadUntilBelowFold: n } = this.props;
      n && !this._preloadingUntilBelowFold ? this.preloadUntilBelowFold() : e && !this._preloadingUntilScroll && this.preloadUntilScroll();
    }, 100));
    g(this, "handleScroll", I((e) => {
      const { offset: n = be, onScroll: i, wrapper: a } = this.props, { loading: r } = this.state, l = a ? this.wrapper : this.eventNode;
      i && i(e), r || Se(this.wrapper, l, n) && (this.destroyScrollEvent(), this.getMoreOnce());
    }, 100));
    g(this, "eventNode", null);
    g(this, "wrapper", null);
    g(this, "state", {
      loading: !1
    });
  }
  get pagesLoaded() {
    const { initialPage: e } = this.props, { pagesLoaded: n } = this.state;
    let i = n;
    return i || (i = typeof e == "number" ? e : _e), i;
  }
  addScrollEvent() {
    const { wrapper: e, hasMore: n, preloadUntilScroll: i } = this.props;
    i && this.preloadUntilScroll(), this._preloadingUntilScroll || (this.eventNode = this.eventNode || document.querySelector(e) || window, n && this.eventNode.addEventListener("scroll", this.handleScroll));
  }
  destroyScrollEvent() {
    const { wrapper: e } = this.props;
    (this.eventNode || document.querySelector(e) || window).removeEventListener("scroll", this.handleScroll);
  }
  getMore() {
    const { currentPage: e = this.pagesLoaded, fetchMore: n, loadMore: i = F, endpoint: a, pageSize: r } = this.props, l = e + 1;
    let c;
    return this.setState({ loading: !0 }), a ? c = n({
      limit: r,
      startsAt: e * r
    }) : c = Promise.all([i({ currentPage: e, nextPage: l })]), c.then(() => new Promise((f, u) => this._isMounted ? this.setState({ pagesLoaded: l }, f) : u()));
  }
  /**
   * Gets more content, then on completion disables loading state, and adds the scroll event.
   */
  getMoreOnce() {
    return this.getMore().then(() => {
      this.setState({ loading: !1 }, () => this.addScrollEvent());
    }, F);
  }
  /**
   * Preloads data until it flows below the bottom of the window
   */
  preloadUntilBelowFold() {
    const {
      hasMore: e,
      onPreloadComplete: n,
      preloadUntilBelowFold: { current: i }
    } = this.props, { loading: a } = this.state;
    if (i) {
      if (!e || we(i)) {
        a && this.setState({ loading: !1 }), e && this.addScrollEvent(), H(n) && n(), this._preloadingUntilBelowFold = !1;
        return;
      }
      this._preloadingUntilBelowFold = !0, this.getMore().then(() => this.preloadUntilBelowFold(), F);
    }
  }
  preloadUntilScroll() {
    const { hasMore: e, onPreloadComplete: n } = this.props;
    if (!ve(this.wrapper) && e) {
      this._preloadingUntilScroll = !0, this.getMoreOnce();
      return;
    }
    this._preloadingUntilScroll && (this._preloadingUntilScroll = !1, H(n) && n());
  }
  reset() {
    const { preloadUntilBelowFold: e } = this.props;
    this.destroyScrollEvent(), this.setState(
      {
        pagesLoaded: void 0
      },
      () => {
        e ? this.preloadUntilBelowFold() : this.addScrollEvent();
      }
    );
  }
  componentDidMount() {
    this._isMounted = !0;
    const { preloadUntilBelowFold: e, wrapper: n } = this.props;
    this.wrapper = document.querySelector(n || "body"), e ? this.preloadUntilBelowFold() : this.addScrollEvent(), window.addEventListener("resize", this.handleResize);
  }
  componentWillUnmount() {
    this._isMounted = !1, this.destroyScrollEvent(), window.removeEventListener("resize", this.handleResize);
  }
  render() {
    const { children: e, loader: n } = this.props, { loading: i } = this.state;
    return /* @__PURE__ */ s.jsxs("div", { "data-fabric-component": "ProgressiveLoader", children: [
      e,
      i && (n || /* @__PURE__ */ s.jsx(ne, { type: "dot" }))
    ] });
  }
}
const B = {
  startsAt: 0,
  // starts at first item
  limit: 25
  // give me 25 results
}, U = class U extends Y.Component {
  constructor(t) {
    super(t), this.fetchMore = (n = B) => {
      const { endpoint: i, onFetch: a } = this.props, { totalItemsCount: r } = this.state, l = Z.extendURL(n, i);
      return ie.ajax.get(l).then(({ data: c }) => (a && a(c), c.total !== r && this.setState({
        totalItemsCount: c.total
      }), c)).catch((c) => {
        console.log(c);
      });
    }, this.updateTotal = (n) => {
      this.setState({
        totalItemsCount: n
      });
    };
    const { totalItemsCount: e } = t;
    this.state = {
      totalItemsCount: e || 1
    };
  }
  componentDidMount() {
    const { preload: t, endpoint: e } = this.props;
    t && e && this.fetchMore(t).then(N.noop, N.noop);
  }
  componentDidUpdate() {
    const { totalItemsCount: t } = this.props, { totalItemsCount: e } = this.state;
    t && t !== e && this.updateTotal(t);
  }
  render() {
    const { children: t, innerRef: e, pageSize: n, pagination: i } = this.props, { totalItemsCount: a } = this.state;
    return i ? /* @__PURE__ */ s.jsx(ge, { ...this.props, fetchMore: this.fetchMore, ref: e, totalItemsCount: a, children: t }) : /* @__PURE__ */ s.jsx(Pe, { ...this.props, fetchMore: this.fetchMore, pageSize: n || B.limit, ref: e, children: t });
  }
};
U.displayName = "ProgressiveLoader";
let W = U;
export {
  W as P
};
//# sourceMappingURL=progressive-loader-BO7uOqw9.mjs.map
